import { Component } from 'vue-property-decorator';
import SubscriptionApi from '@/apis/subscription-api';
import Base from '../Base';

@Component({
})
export default class AccountInvoices extends Base {
  selectedInvoiceId = null;

  async mounted() {
    if (!this.userModule.invoices) {
      const response = await SubscriptionApi.getInvoices();
      this.userModule.setSubscriptionInvoices(response.invoices);
    }
  }
  get invoices() {
    return this.userModule.invoices;
  }

  selectInvoice(invoice) {
    this.selectedInvoiceId = invoice.id;
  }

  downloadInvoice() {
    if (!this.selectedInvoiceId) {
      return;
    }

    window.open(`/api/v1/subscriptions/receipts/${this.selectedInvoiceId}/download`, '_empty');
  }
}
